import Vue from 'vue'
import Vuex from 'vuex'

import texts from './texts'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ime: '',
    priimek: '',
    email: '',
    street: '',
    postOffice: '',
    postNumber: '',
    telephone: '',
    vin: '',
    form: {
      user: {
        id: '',
        key: '',
        ime: '',
        priimek: '',
        email: '',
        title: '',
        street: '',
        postOffice: '',
        postNumber: '',
        telephone: ''
      },
      gdpr: {
        ponudbaNakup: '',
        ponudbaPoprodajni: '',
        personalizacija: '',
        obvescanjeEposta: '',
        obvescanjeSMS: '',
        obvescanjeTelefon: '',
        obvescanePosta: '',
        ePosta: '',
        sms: '',
        telefon: '',
        posta: '',
        sporocila: '',
      }
    },
    buttons: {
      obvescanjeEposta: {
        value: null,
        error: false
      },
      obvescanjeSMS: {
        value: null,
        error: false
      },
      obvescanjeTelefon: {
        value: null,
        error: false
      },
      obvescanePosta: {
        value: null,
        error: false
      }
    },
    checkboxes: {
      sporocila: {
        value: false,
        error: false
      },
      ePosta: {
        value: false,
        error: false
      },
      sms: {
        value: false,
        error: false
      },
      telefon: {
        value: false,
        error: false
      },
      posta: {
        value: false,
        error: false
      }
    },
    dropdowns: {
      gender: {
        validation: false,
        titles: ['Gdin', 'Gđa']
      }
    },
    //ERROR CHECK
    DisclosureOneOpened: false,
    submitted: false,
    checkboxValidation: false,
    checkboxError: false,
    emailError: false,
    smsError: false,
    telephoneError: false,
    ulicaError: false,
    postnaStError: false,
    postaError: false,
    allChannelsNo: false,
    emailClicked: false,
    allValidations: {
      ime: false,
      priimek: false,
      email: false,
      telefon: false,
      sms: false,
      posta: false,
      obvescanjeEposta: false,
      obvescanjeSMS: false,
      obvescanjeTelefon: false,
      obvescanePosta: false
    }
  },
  modules: {
    texts
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js